var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 24.861V10.739C5.33203 6.93363 5.33203 5.03096 6.5036 3.8488C7.67517 2.66663 9.56079 2.66663 13.332 2.66663H18.6653C22.4365 2.66663 24.3221 2.66663 25.4937 3.8488C26.6653 5.03096 26.6653 6.93363 26.6653 10.739V24.861C26.6653 26.8766 26.6653 27.8844 26.0493 28.281C25.0428 28.9294 23.4868 27.5698 22.7041 27.0764C22.0575 26.6685 21.7343 26.4646 21.3753 26.4529C20.9876 26.4401 20.6585 26.6357 19.9599 27.0764L17.412 28.6832C16.7247 29.1165 16.3811 29.3333 15.9987 29.3333C15.6163 29.3333 15.2727 29.1165 14.5853 28.6832L12.0375 27.0764C11.3909 26.6685 11.0676 26.4646 10.7087 26.4529C10.321 26.4401 9.99193 26.6357 9.29319 27.0764C8.51063 27.5698 6.95452 28.9294 5.94796 28.281C5.33203 27.8844 5.33203 26.8766 5.33203 24.861Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3347 17.3334H10.668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3347 13.3334H10.668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3347 21.3334H10.668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24223_7057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 8,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.33337H16V13.3334H24V5.33337Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24223_7057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10.6667C18 11.403 18.597 12 19.3333 12H20.6667C21.403 12 22 11.403 22 10.6667C22 9.93029 21.403 9.33333 20.6667 9.33333H19.3333C18.597 9.33333 18 8.73638 18 8C18 7.26362 18.597 6.66667 19.3333 6.66667H20.6667C21.403 6.66667 22 7.26362 22 8M20 6V12.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceManagement);
export default __webpack_public_path__ + "static/media/invoice-management.02c20dd0612be4991460023af1e21ae8.svg";
export { ForwardRef as ReactComponent };